import React, { useEffect, useState, useCallback } from "react";
import "./courseDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faSquareWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useParams } from "react-router-dom";
import Header from "./header/header";
import Footer from "./Footer";
import { useNavigate, useLocation } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import { ICourseDetails, IUserDetails } from "./EnrollTypes";
import { getUserCountry, PopulateContext, getDiscountPercentage } from "../App";
import engBack from "../images/general-bg.png";
import { useCourses } from "./Contexts/CoursesContext";
import { useEnrollee } from "./Contexts/EnrolleeContext";
import { useUsers } from "./Contexts/UsersContext";
import AskExpertModal from "./AskExpertModal";
import { RoadmapSuccess } from "./RoadmapSuccess";
import { RoadMapModal } from "./RoadMapModal";



const CourseDetails: React.FC = () => {
  const { Enrollee, setEnrolleeContext } = useEnrollee();
  const { User, setUserContext, setUsersContext } = useUsers();
  const { courses, setCoursesContext } = useCourses();
  const [user, setUser] = useState<IUserDetails>();
  const [Course, setCourse] = useState<ICourseDetails>();
  const [callToAction, setCallToAction] = useState("Enroll");
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [fullStarAmount, setFullStarAmount] = useState(0);
  const [halfStarAmount, setHalfStarAmount] = useState(0);
  const [nullStarAmount, setNullStarAmount] = useState(0);
  const [ready, setReady] = useState(false);
  const [showEnrollbtn, setShowEnrollbtn] = useState(true);
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");
  const [pricePayable, setPricePayable] = useState(0);
  const [PromoActive, setPromoActive] = useState(false);
  const [slashedPrice, setSlashedPrice] = useState(0);
  const [askExpert, setAskExpert] = useState(false);
  const [showroadmap, setShowroadmap] = useState(false);
  const [showSuccess, setShowsuccess] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState<any>({}); 
  const [promoInfo, setPromoInfo] = useState({IsSpecialPromo: false, SpecialCourse: ""});
  const location = useLocation()


  
  let params: any = useParams();
  const courseSlug = params["slug"];


  let navigate = useNavigate();

  const gotoEnroll = (courseName: string) => {
    // Convert courseName to slug: lowercase, replace spaces and special chars with hyphens
    const slug = courseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    navigate("/enroll/" + slug);
  };

  //  <Route path="enroll/:ids" element={<EnrollForm />} />

  const handleDownload = () => {
    setShowroadmap(false);
    setShowsuccess(true);
    setTimeout(() => {
      setShowsuccess(false);
    }, 3000);
  };

const handleAskExpert = ()=>{
  setAskExpert(!askExpert)
};
const handleShowRoadMap=()=>{
  setShowroadmap(!showroadmap)
}

const setPromoDetails = async () => {
  const {
    IsSpecialPromo, 
    SpecialCourse
  } = await getDiscountPercentage();

  setPromoInfo({
    IsSpecialPromo: IsSpecialPromo, 
    SpecialCourse: SpecialCourse
  });
};

useEffect(()=>{
  const getValues = async ()=> {
    if(courses){
      let selectedCourse = courses.filter((course:any) => course?.CourseName === promoInfo.SpecialCourse);
      setSelectedCourse(selectedCourse[0]);
    }
  }
  setPromoDetails();
  getValues();
},[courses, promoInfo.SpecialCourse])


  const handleModalClose = () => {
    setShowModal(false);
    setModalContent("");
  };

  const fullStar = Array(fullStarAmount).fill(null);
  const halfStar = Array(halfStarAmount).fill(null);
  const nullStar = Array(nullStarAmount).fill(null);


  const priceSplitter = (number: any) =>
    number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // const courseId = params["ids"];

  const setDetailsIfCourseExist = useCallback(
    async (Course: any, userDetails: any) => {
      const StarAmount = Number(Course?.Tutor?.Rating);
      if (StarAmount === 0) {
        setNullStarAmount(5);
      } else {
        const wholevalue = Math.floor(StarAmount / 1);
        const halfvalue = Math.round(StarAmount % 1);
        setFullStarAmount(wholevalue);
        setHalfStarAmount(halfvalue);
        setNullStarAmount(Math.floor(5 - (wholevalue + halfvalue)));
      }
      let price: any = 0;
      switch (userDetails.continentCode) {
        case "EU":
          if (userDetails.countryCode === "GB") {
            setCurrencySymbol("£");
            price = Course?.Price?.priceInEuros;
          } else {
            setCurrencySymbol("€");
            price = Course?.Price?.priceInEuros;
          }
          break;
        case "AF":
          if (userDetails.countryCode === "NG") {
            setCurrencySymbol("NGN");
            price = (Course?.Price?.priceInNaira || 0) * 1000;
          } else {
            setCurrencySymbol("$");
            price = Course?.Price?.priceForOtherAfricans;
          }
          break;
        default:
          setCurrencySymbol("$");
          price = Course?.Price?.priceInDollars;
      }

      const discount = Course?.discount || 0;
      const showDiscount = Course?.showDiscount;
      setPricePayable(price);
      const { promoActive } = await getDiscountPercentage();
      if (promoActive && showDiscount) {
        setSlashedPrice(price);
        setPricePayable(Math.ceil(price - (discount / 100) * price));
        setPromoActive(promoActive);
      }
      if (showDiscount && !promoActive) {
        setSlashedPrice(price);
        setPricePayable(Math.ceil(price - (discount / 100) * price));
        setPromoActive(true);
      }
      setReady(true);
    },
    []
  );

  const getCourseandUserData = useCallback(
    async (courseSlug: string) => {
      const userDetails = await getUserCountry();
      const userId = localStorage.getItem("UserId");
      try {
        if (User) {
          setUser(User);
        } else {
          if (userId) {
            const value = await PopulateContext("Users");
            if (value) {
              const _users = value.filter((each: any) => each.id === userId);
              setUser(_users[0]);
              setUsersContext(value);
              setUserContext(_users[0]);
            }
          }
        }

        if (courses) {
          // let value: any = courses?.filter((each: any) => each.id === courseId);
          let value: any = courses?.filter(
            (each: any) =>
              each.CourseName &&
              each.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") === courseSlug
          );
          setCourse(value[0]);
          setDetailsIfCourseExist(value[0], userDetails);
        } else {
          const value = await PopulateContext("Courses");
          if (value) {
            const _course: any = value?.filter(
            (each: any) =>
              each.CourseName &&
              each.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") === courseSlug
          );
            setCourse(_course[0]);
            const newValue = value.filter(
              (each: any) =>
                each.isDeleted === false && each.isArchive === false
            );
            setCoursesContext(newValue);
            setDetailsIfCourseExist(_course[0], userDetails);
          }
        }

        if (userId) {
          if (Enrollee) {
            let value: any = Enrollee?.filter(
              (each: any) =>
                each?.email === user?.email &&
                each?.course === Course?.CourseName
            );
            if (value[0]) {
              if (value[0]?.status === "Partial-payment") {
                setCallToAction("Pay outstanding fees");
              } else {
                setShowEnrollbtn(false);
              }
            }
          } else {
            const value = await PopulateContext("Enrollees");
            if (value) {
              const _enrollees: any = value?.filter(
                (each: any) =>
                  each?.email === user?.email &&
                  each?.course === Course?.CourseName
              );
              setEnrolleeContext(value);
              if (_enrollees[0]) {
                if (_enrollees[0]?.status === "Partial-payment") {
                  setCallToAction("Pay outstanding fees");
                } else {
                  setShowEnrollbtn(false);
                }
              }
            }
          }
        }
      } catch (error: any) {
        setShowModal(true);
        setModalContent("An Error Occured in fetching course details");
      }
    },
    [
      Course,
      user,
      Enrollee,
      User,
      courses,
      setUserContext,
      setUsersContext,
      setCoursesContext,
      setEnrolleeContext,
      setDetailsIfCourseExist,
    ]
  );

  useEffect(() => {
    getCourseandUserData(courseSlug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseSlug]);

  return (
    <div className="detail-content">
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>

      <AskExpertModal isOpen={askExpert} onClose={handleAskExpert} course={Course?.CourseName} />


      <RoadMapModal
        displayModal={showroadmap}
        handleDownload={handleDownload}
        closeShow={handleShowRoadMap}
      />
      <RoadmapSuccess Course={selectedCourse} onClose={handleDownload} Showsuccess={showSuccess} /> 

      {ready ? (
        <div>
          <Header />
          <div className="headmid"></div>
          

          <div
            className="relative w-full h-[512px] -mt-[100px]  bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${engBack})`,
            }}
          >
          
            <div className="absolute inset-0 bg-black opacity-50"></div>
            {(location.pathname === `/coursedetails/${selectedCourse?.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`) &&

              <div onClick={handleShowRoadMap}  className="cursor-pointer   max-sm:h-auto h-[40px] flex  items-center top-0  z-30">
               <h4  className='text-[#ffffff] text-center h-full  bg-green-600 pt-2  textsize  z-[50]   w-full '>Download Course Roadmap</h4>
           </div>
          }

             

            <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
              <h1 className="text-white text-2xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-4">
                {Course?.CourseName}
              </h1>

              <div className=" text-[#FFFFFF] text-[18px] font-[500] flex gap-3">
                <button
                  className="px-8 py-2 rounded-[8px]  bg-[#D89F0D]"
                  onClick={() => {
                    gotoEnroll(Course?.CourseName || " ");
                  }}
                >
                  Enroll now
                </button>
                <button
                  className=" px-4 py-2 rounded-[8px] bg-[#367E3E]"
                  onClick={() => {
                    setAskExpert(true)
                    // navigate("/consult");
                  }}
                >
                  Ask an expert
                </button>
              </div>
            </div>
            <div className="absolute -bottom-28 md:-bottom-24 lg:-bottom-20 xl:-bottom-20 2xl:-bottom-20 left-0 right-0 flex justify-center mb-4 mx-auto px-4">
              <div className="bg-green-600 text-white h-fit w-fit rounded-lg lg:w-[70%] xl:w-[70%]">
                <div className="flex flex-col justify-between mx-12 my-3 gap-2 ">
                  <div className="flex flex-col gap-2 lg:flex-row xl:flex-row justify-between items-start w-full">
                    <div className="flex text-sm lg:text-lg xl:text-lg gap-2 w-full  lg:w-1/2 xl:w-1/2">
                      <span className="w-1/2">School:</span>
                      <span className="font-medium lg:font-semibold xl:font-semibold w-1/2">
                        {Course?.Category === "ProductDesign"
                          ? "Design"
                          : Course?.Category === "SoftwareEngineering"
                          ? "Engineering"
                          : Course?.Category === "ProductManagement"
                          ? "Product"
                          : Course?.Category === "No-code"
                          ? "NoCode Path"
                          : Course?.Category === "cybersecurity"
                          ? "Cyber Security"
                          : Course?.Category}
                      </span>
                    </div>
                    <div className="flex text-sm lg:text-lg xl:text-lg gap-2 w-full  lg:w-1/2 xl:w-1/2">
                      <span className="w-1/2">Price:</span>
                      <div className="flex flex-col">
                        <span className="font-medium lg:font-semibold xl:font-semibold">
                          {currencySymbol}
                          <span>{priceSplitter(pricePayable)}</span>
                        </span>
                        {PromoActive && (
                          <span className=" font-medium text-[#A4C8A8] line-through">
                            {currencySymbol}
                            <span>{priceSplitter(slashedPrice)}</span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 lg:flex-row xl:flex-row justify-between items-start w-full">
                    <div className="flex text-sm lg:text-lg xl:text-lg gap-2 w-full  lg:w-1/2 xl:w-1/2">
                      <span className="w-1/2">Course Duration:</span>
                      <span className="font-medium lg:font-semibold xl:font-semibold w-1/2">
                        {Course?.Duration}
                      </span>
                    </div>
                    <div className="flex text-sm lg:text-lg xl:text-lg gap-2 w-full  lg:w-1/2 xl:w-1/2">
                      <span className="w-1/2">Program Type:</span>
                      <span className="font-medium lg:font-semibold xl:font-semibold w-1/2">
                        Online
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <div className="flex flex-col justify-center lg:flex-row xl:flex-row 2xl:flex-row gap-10 mt-20 mx-auto w-full p-10">
            <div className="w-full lg:w-[50%] xl:w-50%">
              <p style={{ textAlign: "justify", fontWeight: "400" }}>
                <div className="row">
                  {Course?.CourseDescription?.map((item: any) => (
                    <div
                      key={item}
                      className="col-12"
                      style={{ marginBottom: "10px" }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </p>
              {showEnrollbtn ? (
                <>
                  <button
                    className="btn btn-success flex mx-auto"
                    style={{ fontSize: "22px" }}
                    onClick={() => {
                      gotoEnroll(Course?.CourseName || " ");
                    }}
                  >
                    {callToAction}
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="btn btn-outline-warning flex mx-auto"
                    style={{ fontSize: "24px" }}
                  >
                    Contact Support Team
                  </button>
                </>
              )}
            </div>
            <div className="w-full lg:w-[50%] xl:w-50% 2xl:w-50% border rounded-lg shadow-md p-8">
              {Course?.noTutor === true ? (
                <></>
              ) : (
                <>
                  <div className="Tutor">
                    <div>{Course?.Tutor?.Note}</div>
                    <div className="row" style={{ marginTop: "20px" }}>
                      <div className="col-md-2">
                        <img
                          src={Course?.Tutor?.Image}
                          style={{
                            height: "60px",
                            width: "60px",
                            borderRadius: "90px",
                          }}
                          alt="tutor logo"
                        />
                      </div>
                      <div className="col-md-10">
                        <div className="row">
                          <div className="col-6">
                            <div className="font-semibold">
                              {Course?.Tutor?.Name}
                            </div>

                            <p>
                              {Course?.Tutor?.Title}{" "}
                              <h4 className="text-lg">Tutor</h4>
                            </p>
                          </div>
                          <div className="col-6">
                            <div>
                              {fullStar.map((_, index) => (
                                <FontAwesomeIcon
                                  key={index}
                                  style={{
                                    color: "#d1ce16",
                                    fontSize: "18px",
                                    marginRight: "7px",
                                  }}
                                  icon={faStar}
                                />
                              ))}
                              {halfStar.map((_, index) => (
                                <FontAwesomeIcon
                                  key={index}
                                  style={{
                                    color: "#d1ce16",
                                    fontSize: "18px",
                                    marginRight: "7px",
                                  }}
                                  icon={faStarHalfAlt}
                                />
                              ))}
                              {nullStar.map((_, index) => (
                                <FontAwesomeIcon
                                  key={index}
                                  style={{
                                    color: "#ebeec5",
                                    fontSize: "18px",
                                    marginRight: "7px",
                                  }}
                                  icon={faStar}
                                />
                              ))}
                            </div>
                            <div className="flex items-center gap-1">
                              <a
                                href="https://api.whatsapp.com/send?phone=37256704920"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon
                                  icon={faSquareWhatsapp}
                                  size="lg"
                                  style={{ color: "#367E3E" }}
                                />
                              </a>

                              {Course?.Tutor?.LinkedinUrl && <a href={Course?.Tutor?.LinkedinUrl}>
                                <FontAwesomeIcon
                                  className=" inline"
                                  icon={faLinkedin}
                                  size="lg"
                                  style={{ color: "#2813c9" }}
                                />
                              </a>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <br />
                </>
              )}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center mx-auto">
            <h5 className="text-[#0F4B16] font-semibold">Course Outline</h5>
            <div>
              <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-x-20">
                {Course?.CourseOutline.map((item: string) => (
                  <div key={item} className="col-12">
                    <div
                      className="flex gap-2 items-start"
                      style={{
                        marginBottom: "10px",
                        padding: "10px",
                      }}
                    >
                      <img
                        src="../../images/files-sharing.png"
                        alt="doy academy"
                        className="w-4"
                      />
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center lg:flex-row xl:flex-row 2xl:flex-row gap-10 mt-20 mx-auto w-full p-10 bg-[#F2FFD8]">
            {Course?.TargetAudience && Course?.TargetAudience.length > 0 && (
              <div className="w-full lg:w-[50%] xl:w-50% 2xl:w-50% h-fit border rounded-lg shadow-md px-4 py-5 bg-white">
                <h5 className="text-center text-[#0F4B16] font-semibold">
                  Target Audience
                </h5>
                <div>
                  <div className="row">
                    {Course?.TargetAudience.map((item: string) => (
                      <div key={item} className="col-12">
                        <div
                          className="flex gap-2 items-start"
                          style={{
                            marginBottom: "10px",
                            padding: "10px",
                          }}
                        >
                          <img
                            src="../../images/rounded.png"
                            alt="doy academy"
                            className="w-4"
                          />
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {Course?.CourseDelivery && Course?.CourseDelivery.length > 0 && (
              <div className="w-full lg:w-[50%] xl:w-50% 2xl:w-50% h-fit border rounded-lg shadow-md px-4 py-5 bg-white">
                <h5 className="text-center text-[#0F4B16] font-semibold">
                  Course Delivery
                </h5>
                <div className="row">
                  {Course?.CourseDelivery.map((item: string) => (
                    <div key={item} className="col-12">
                      <div
                        className="flex gap-2 items-start"
                        style={{
                          marginBottom: "10px",
                          padding: "10px",
                        }}
                      >
                        <img
                          src="../../images/rounded.png"
                          alt="doy academy"
                          className="w-4"
                        />
                        {item}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Footer />
        </div>
      ) : (
        <div className="academystyle flex justify-center items-center min-h-screen">
          <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
          <ClipLoader size={50} color="#047E35" />
        </div>
      )}
    </div>
  );
};
export default CourseDetails;